import animateScrollTo from "animated-scroll-to"

export function initScroll() {
	scroll()
}

function scroll() {
	$(".scroll").on("click", function (e) {
		if (window.innerWidth >= 992) {
			e.preventDefault()

			animateScrollTo(document.querySelector($(this).attr("href")), {
				verticalOffset: 0,
				cancelOnUserAction: false,
			})
		}
	})

	if ($('.plane').length && window.innerWidth >= 992) {
		addEventListener("scroll", planeScroll)
		planeScroll()
	}
}

function planeScroll() {
	const $plane = $('.plane')
	const $line = $('.line')
	let offset = -$('.section-why').offset().top + window.scrollY + (window.innerHeight / 2)

	if (!$('.number.last').hasClass('active')) {
		$line.css('top', (offset - 4990) + 'px')
		$plane.css('top', offset + 'px')
	}

	$('.number').each(function () {
		const $el = $(this)
		const el = this.getBoundingClientRect()
		const top = el.top + window.scrollY

		$el.removeClass('active')

		if ((window.scrollY + (window.innerHeight / 2)) > top) {
			$el.addClass('active')
		}
	})
}
